import { render, staticRenderFns } from "./Circles.vue?vue&type=template&id=4af3ab58&"
import script from "./Circles.vue?vue&type=script&lang=js&"
export * from "./Circles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports